import { McAction } from '../../IMcAction';
import { NotificationProgressInfo } from '../../../core/server-notification/progress-notification.interfaces';
import { IProgressState } from './IProgressSate';

export function calculationProgressReceived(state: IProgressState, action: McAction): IProgressState {
    const notification = action.payload as NotificationProgressInfo;
    return Object.assign({}, state, {
        calculation: {
            ...state.calculation,
            notification
        }
    });
}

export function clearCalculationProgress(state: IProgressState, action: McAction): IProgressState {
    const notification = {};
    return Object.assign({}, state, {
        calculation: {
            ...state.calculation,
            notification: {
                ...state.calculation.notification,
                totalItemsCount: 0
            }
        }
    });
}

export function importDataProgressReceived(state: IProgressState, action: McAction): IProgressState {
    const notification = action.payload as NotificationProgressInfo;
    return Object.assign({}, state, {
        importData: {
            ...state.importData,
            notification
        }
    });
}

export function clearImportDataProgress(state: IProgressState, action: McAction): IProgressState {
    const notification = {};
    return Object.assign({}, state, {
        importData: {
            ...state.importData,
            notification: {
                ...state.importData.notification,
                totalItemsCount: 0,
                labId: ''
            }
        }
    });
}

export function cancelImportDataProgress(state: IProgressState, action: McAction): IProgressState {
    return Object.assign({}, state, {
        importData: {
            ...state.importData,
            notification: {
                ...state.importData.notification,
                status: 'Canceled'
            }
        }
    });
}

export function importInstrumentsProgressReceived(state: IProgressState, action: McAction): IProgressState {
    const notification = action.payload as NotificationProgressInfo;
    return Object.assign({}, state, {
        importInstruments: {
            ...state.importInstruments,
            notification
        }
    });
}

export function clearImportInstrumentsProgress(state: IProgressState, action: McAction): IProgressState {
    const notification = {};
    return Object.assign({}, state, {
        importInstruments: {
            ...state.importInstruments,
            notification: {
                ...state.importInstruments.notification,
                totalItemsCount: 0,
                labId: ''
            }
        }
    });
}

export function cancelImportInstrumentsProgress(state: IProgressState, action: McAction): IProgressState {
    return Object.assign({}, state, {
        importData: {
            ...state.importInstruments,
            notification: {
                ...state.importInstruments.notification,
                status: 'Canceled'
            }
        }
    });
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/progress/progress.reducer.logic.ts